import { render, staticRenderFns } from "./ParticipantStudies.vue?vue&type=template&id=65a5ec24&"
import script from "./ParticipantStudies.vue?vue&type=script&lang=js&"
export * from "./ParticipantStudies.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantStudies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports